import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  style: {
    "text-align": "center",
    "margin": "30px 0"
  }
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  style: {
    "display": "flex",
    "justify-content": "center",
    "width": "100%"
  }
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
  key: 0,
  style: {
    "text-align": "center",
    "font-size": "16px",
    "margin-bottom": "30px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_welfare_details_brief_m = _resolveComponent("welfare_details_brief_m");
  return $setup.Client === 0 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    style: _normalizeStyle(['zoom:' + ($setup.Client ? '20%' : '') + ';' + 'border-top:1px solid #E3E3E3;', {
      "min-width": "1560px"
    }])
  }, [_createElementVNode("div", _hoisted_1, [$setup.get_data.id != 4 ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString($setup.get_data.benefitName), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("p", {
    class: "benefit-details-img",
    innerHTML: $setup.get_data.benefitDetails,
    style: {
      "margin-bottom": "100px",
      "width": "80%"
    }
  }, null, 8, _hoisted_4)]), $setup.route.params.id == 4 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_cache[1] || (_cache[1] = _createElementVNode("span", null, "想要了解更多，点击", -1)), _createElementVNode("span", {
    style: {
      "color": "#28ABC4",
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.call && $setup.call(...args))
  }, "添加客服")])) : _createCommentVNode("", true)], 4)) : (_openBlock(), _createBlock(_component_welfare_details_brief_m, {
    key: 1
  }));
}